// Whether the company is still bringing ServiceTitan over (history fix 4, 22 Oct): an empty ledger or
// an empty stockroom says why while it is, since Flowology's books and stock start at the switch. As
// the migration banner knows it: the owner's written OK is in and the switch to live isn't done, or
// the company mirrors ServiceTitan. Read once a page load; a role that may not read the migration, or
// a company that never had ServiceTitan, gets false.

import { useEffect, useState } from 'react';
import { client } from '../api.ts';
import { isMirroring } from '../shared/mirror.ts';
import type { Step } from './model.ts';

/** What the empty books and stock say while ServiceTitan comes over. */
export const BEFORE_THE_SWITCH =
  'Books start at the switch from ServiceTitan; imported history shows in Reports.';
export const STOCK_BEFORE_THE_SWITCH =
  'Stock starts at the switch from ServiceTitan; imported purchase orders show under Purchase orders.';

/** From the cutover checklist: authorised, and not gone live. */
export function bringingOverOf(steps: readonly Pick<Step, 'key' | 'done'>[]): boolean {
  const done = (k: string) => steps.some((s) => s.key === k && s.done);
  return done('authorised') && !done('went_live');
}

let read: Promise<boolean> | null = null;

/** True while the company is still bringing ServiceTitan over; false until known. */
export function useBringingOver(): boolean {
  const [over, setOver] = useState(isMirroring());
  useEffect(() => {
    if (isMirroring()) return;
    let live = true;
    read ??= client
      .call<{ steps: Step[] }>('migration.cutoverChecklist', {})
      .then((c) => bringingOverOf(c.steps))
      .catch(() => false);
    void read.then((b) => live && setOver(b));
    return () => {
      live = false;
    };
  }, []);
  return over;
}
